/**
 * ACIL Intelligence - Forgot Password Page
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import api, { formatApiError } from '../utils/api';
import { Shield, AlertCircle, CheckCircle2, ArrowLeft } from 'lucide-react';
import '../App.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email, frontend_origin: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" data-testid="forgot-password-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon"><Shield size={22} /></div>
          <span className="auth-logo-text">ACIL Intelligence</span>
        </div>

        {sent ? (
          <div data-testid="forgot-password-success" style={{ textAlign: 'center' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(34,197,94,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <CheckCircle2 size={28} color="var(--success)" />
            </div>
            <h1 className="auth-title" style={{ fontSize: 22 }}>Revisa tu correo</h1>
            <p className="auth-subtitle">
              Si el email existe en nuestro sistema, recibirás instrucciones para restablecer tu contraseña.
            </p>
            <Link to="/" className="btn-primary" style={{ textDecoration: 'none', display: 'inline-flex', marginTop: 8 }} data-testid="back-to-login-btn">
              <ArrowLeft size={16} /> Volver al login
            </Link>
          </div>
        ) : (
          <>
            <h1 className="auth-title" style={{ fontSize: 22 }}>Recuperar contraseña</h1>
            <p className="auth-subtitle">
              Ingresa tu email y te enviaremos instrucciones para restablecer tu contraseña.
            </p>

            {error && (
              <div className="auth-error-banner" data-testid="forgot-password-error">
                <AlertCircle size={16} /><span>{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit} data-testid="forgot-password-form">
              <div style={{ marginBottom: 20 }}>
                <label className="acil-label" htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  className="acil-input"
                  placeholder="tu@acilmexico.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                  data-testid="forgot-email-input"
                />
              </div>
              <button type="submit" className="btn-primary" disabled={loading} style={{ width: '100%', height: 48 }} data-testid="forgot-submit-btn">
                {loading ? <><div className="acil-spinner" /> Enviando...</> : 'Enviar instrucciones'}
              </button>
            </form>

            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link to="/" style={{ fontSize: 13, color: 'var(--muted)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6 }} data-testid="back-to-login-link">
                <ArrowLeft size={14} /> Volver al login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
